// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Website Audit Logs — compact table layout */

.wal-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 148px);
  min-height: 420px;
  max-height: calc(100vh - 136px);
}

.wal-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.wal-search {
  flex: 1 1;
  min-width: 140px;
  max-width: 220px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
}

.wal-select,
.wal-date {
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
  color: #475569;
}

.wal-date {
  width: 130px;
}

.wal-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
}

.wal-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.wal-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.wal-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.wal-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.wal-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.wal-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.wal-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.wal-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.wal-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.wal-table-panel {
  flex: 1 1;
  min-height: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wal-table-scroll {
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.wal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.wal-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafbfc;
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e2e8f0;
}

.wal-table thead th:last-child {
  width: 48px;
}

.wal-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}

.wal-table tbody tr:hover {
  background: #f8fafc;
}

.wal-action {
  font-size: 13px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  text-transform: lowercase;
}

.wal-action--create { background: #dcfce7; color: #166534; }
.wal-action--update { background: #dbeafe; color: #1d4ed8; }
.wal-action--delete { background: #fee2e2; color: #991b1b; }
.wal-action--sync { background: #fef9c3; color: #854d0e; }
.wal-action--default { background: #f1f5f9; color: #475569; }

.wal-resource {
  display: block;
  font-weight: 500;
  color: #334155;
}

.wal-resource-id {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  font-family: ui-monospace, monospace;
}

.wal-user {
  display: block;
  color: #334155;
}

.wal-ip {
  display: block;
  font-size: 13px;
  color: #94a3b8;
}

.wal-time {
  font-size: 15px;
  color: #64748b;
  white-space: nowrap;
}

.wal-badge {
  font-size: 14px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  text-transform: uppercase;
}

.wal-badge--ok {
  background: #dcfce7;
  color: #166534;
}

.wal-badge--fail {
  background: #fee2e2;
  color: #991b1b;
}

.wal-icon-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.wal-table tbody tr:hover .wal-icon-btn {
  color: #94a3b8;
}

.wal-icon-btn:hover {
  background: #f1f5f9;
  color: #475569;
}

.wal-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
  font-size: 15px;
  color: #64748b;
}

.wal-pagination-btns {
  display: flex;
  gap: 6px;
}

.wal-empty,
.wal-loading {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 15px;
  padding: 24px;
}

.wal-spin {
  animation: wal-spin 0.8s linear infinite;
}

@keyframes wal-spin {
  to { transform: rotate(360deg); }
}

.wal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  padding: 16px;
}

.wal-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 640px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.wal-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.wal-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.wal-modal-sub {
  font-size: 13px;
  color: #94a3b8;
  font-family: ui-monospace, monospace;
  margin-top: 2px;
}

.wal-modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wal-modal-body {
  padding: 16px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.wal-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
}

.wal-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.wal-detail-item {
  padding: 10px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
}

.wal-detail-item label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.wal-detail-item span {
  font-size: 15px;
  color: #334155;
  font-weight: 500;
}

.wal-json {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  font-size: 13px;
  font-family: ui-monospace, monospace;
  overflow-x: auto;
  max-height: 160px;
  margin-top: 8px;
}

.wal-json pre {
  margin: 0;
  white-space: pre-wrap;
}

@media (max-width: 900px) {
  .wal-page {
    height: auto;
    max-height: none;
  }

  .wal-detail-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/website/AuditLogViewer.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Website Audit Logs — compact table layout */\n\n.wal-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 148px);\n  min-height: 420px;\n  max-height: calc(100vh - 136px);\n}\n\n.wal-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.wal-search {\n  flex: 1;\n  min-width: 140px;\n  max-width: 220px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n}\n\n.wal-select,\n.wal-date {\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n  color: #475569;\n}\n\n.wal-date {\n  width: 130px;\n}\n\n.wal-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.wal-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.wal-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.wal-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.wal-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.wal-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.wal-btn--primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.wal-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.wal-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.wal-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.wal-table-panel {\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.wal-table-scroll {\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.wal-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 15px;\n}\n\n.wal-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fafbfc;\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.wal-table thead th:last-child {\n  width: 48px;\n}\n\n.wal-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: middle;\n}\n\n.wal-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.wal-action {\n  font-size: 13px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 6px;\n  text-transform: lowercase;\n}\n\n.wal-action--create { background: #dcfce7; color: #166534; }\n.wal-action--update { background: #dbeafe; color: #1d4ed8; }\n.wal-action--delete { background: #fee2e2; color: #991b1b; }\n.wal-action--sync { background: #fef9c3; color: #854d0e; }\n.wal-action--default { background: #f1f5f9; color: #475569; }\n\n.wal-resource {\n  display: block;\n  font-weight: 500;\n  color: #334155;\n}\n\n.wal-resource-id {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  font-family: ui-monospace, monospace;\n}\n\n.wal-user {\n  display: block;\n  color: #334155;\n}\n\n.wal-ip {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.wal-time {\n  font-size: 15px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.wal-badge {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  text-transform: uppercase;\n}\n\n.wal-badge--ok {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.wal-badge--fail {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.wal-icon-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #cbd5e1;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wal-table tbody tr:hover .wal-icon-btn {\n  color: #94a3b8;\n}\n\n.wal-icon-btn:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.wal-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-top: 1px solid #f1f5f9;\n  flex-shrink: 0;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.wal-pagination-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.wal-empty,\n.wal-loading {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 24px;\n}\n\n.wal-spin {\n  animation: wal-spin 0.8s linear infinite;\n}\n\n@keyframes wal-spin {\n  to { transform: rotate(360deg); }\n}\n\n.wal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  padding: 16px;\n}\n\n.wal-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 640px;\n  max-height: calc(100vh - 32px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n}\n\n.wal-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.wal-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.wal-modal-sub {\n  font-size: 13px;\n  color: #94a3b8;\n  font-family: ui-monospace, monospace;\n  margin-top: 2px;\n}\n\n.wal-modal-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wal-modal-body {\n  padding: 16px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.wal-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.wal-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.wal-detail-item {\n  padding: 10px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #f1f5f9;\n}\n\n.wal-detail-item label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.wal-detail-item span {\n  font-size: 15px;\n  color: #334155;\n  font-weight: 500;\n}\n\n.wal-json {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n  font-size: 13px;\n  font-family: ui-monospace, monospace;\n  overflow-x: auto;\n  max-height: 160px;\n  margin-top: 8px;\n}\n\n.wal-json pre {\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 900px) {\n  .wal-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .wal-detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
